import React, { createContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import productTypes from '@general/productTypes';
import useMemberDuesEligibilityFromAPI from '@hooks/apiLegacy/useMemberDuesEligibilityFromAPI';
import lineItemPropTypes from '@react/propTypes/lineItemPropTypes';

export const CartItemMembershipContext = createContext();

const CartItemMembershipProvider = ({ children, membershipDataForMember }) => {
    const [membershipCartItem, setMembershipCartItem] = useState();
    const { memberDuesEligibility } = useMemberDuesEligibilityFromAPI({ id: membershipDataForMember.memberId });

    useEffect(() => {
        if (!membershipDataForMember || !memberDuesEligibility) {
            return;
        }

        const duesInCart = membershipDataForMember.dues.find(dues => dues.product_type === productTypes.MEMBERSHIP);
        setMembershipCartItem(duesInCart);
    }, [memberDuesEligibility, membershipDataForMember]);

    return (
        <CartItemMembershipContext.Provider value={{ membershipDataForMember, membershipCartItem }}>
            {children}
        </CartItemMembershipContext.Provider>
    );
};

CartItemMembershipProvider.propTypes = {
    children: PropTypes.node.isRequired,
    membershipDataForMember: PropTypes.shape({
        memberId: PropTypes.number.isRequired,
        dues: PropTypes.arrayOf(lineItemPropTypes),
    }),
};

export default CartItemMembershipProvider;
